import { create } from "zustand"

export interface User {
  id: number
  email: string
  username?: string
  // true = user chưa tự đổi mật khẩu → bị bắt buộc đổi trước khi vào admin
  mustChangePassword?: boolean
  [key: string]: any
}

export interface Permission {
  [controller: string]: {
    [action: string]: {
      enabled: boolean
      policy: string
    }
  }
}

interface AuthState {
  user: User | null
  permissions: Permission | null
  setAuth: (user: User, permissions: Permission) => void
  clearAuth: () => void
}

export const useAuthStore = create<AuthState>(set => ({
  user: null,
  permissions: null,

  setAuth: (user, permissions) => {
    set({ user, permissions })
  },
  clearAuth: () => set({ user: null, permissions: null }),
}))
